import type { App } from 'utils/app/types';

/**
 * Returns a function that determines if an event is not of a type.
 */
export function isNot(eventType: string) {
  return function isType(event: App.Event): boolean {
    return eventType !== event.type;
  };
}
